import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import QRCode from 'qrcode';
import handleClipboard from '@/utils/clipboard';
import PtButton from '@com/pt-components/pt-button/index.vue';

export default {
  components: {
    PtButton: PtButton
  },
  props: {
    text: {
      type: String,
      required: true
    },
    // 二维码放大效果
    preview: {
      type: Boolean,
      default: false
    },
    // 复制链接按钮 默认true展示
    visible: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      dataURL: '',
      copied: false,
      time: null
    };
  },


  watch: {
    text: function text(val) {
      this.toDateURL(val);
    }
  },

  mounted: function mounted() {
    this.toDateURL(this.text);
  },


  methods: {
    toDateURL: function toDateURL(text) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return QRCode.toDataURL(text, { margin: 0 });

              case 2:
                _this.dataURL = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    copyLink: function copyLink() {
      var _this2 = this;

      this.time && clearTimeout(this.time);
      handleClipboard(this.text, {
        target: '.copy-link',
        delegateTarget: document.querySelector('#clipboardElement')
      });
      this.copied = true;
      // 3秒后重新展示‘复制链接’
      this.time = setTimeout(function () {
        _this2.copied = false;
      }, 3000);
    }
  }
};